(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ============================================================
     FAQ ACCORDION
     ============================================================ */
  function initFaq() {
    document.querySelectorAll('[data-furlo-faq]').forEach(function (faq) {
      faq.querySelectorAll('.furlo-faq__item').forEach(function (item) {
        var button = item.querySelector('.furlo-faq__btn');
        if (!button) return;
        button.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          faq.querySelectorAll('.furlo-faq__item').forEach(function (entry) {
            entry.classList.remove('is-open');
            var btn = entry.querySelector('.furlo-faq__btn');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  /* ============================================================
     GALLERY — thumbnails click + mobile swipe
     ============================================================ */
  function initGallery() {
    var mainWrap = document.getElementById('furlo-main-image-wrap');
    var mainImg  = document.getElementById('furlo-main-image');
    var thumbsEl = document.getElementById('furlo-thumbs');
    var dotsEl   = document.getElementById('furlo-gallery-dots');

    if (!mainImg || !thumbsEl) return;

    var thumbs = Array.from(thumbsEl.querySelectorAll('.furlo-thumb[data-src]'));
    if (!thumbs.length) return;

    // Build dots for mobile
    if (dotsEl) {
      thumbs.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'furlo-gallery__dot' + (i === 0 ? ' is-active' : '');
        dotsEl.appendChild(dot);
      });
    }

    // Build lightbox (appended to body to avoid stacking-context issues)
    var lightbox = document.createElement('div');
    lightbox.className = 'furlo-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Zoom produit');
    lightbox.innerHTML = [
      '<img class="furlo-lightbox__img" alt="Zoom produit">',
      '<button class="furlo-lightbox__close" type="button" aria-label="Fermer">',
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg>',
      '</button>',
      '<button class="furlo-lightbox__nav furlo-lightbox__nav--prev" type="button" aria-label="Image précédente">',
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"/></svg>',
      '</button>',
      '<button class="furlo-lightbox__nav furlo-lightbox__nav--next" type="button" aria-label="Image suivante">',
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"/></svg>',
      '</button>'
    ].join('');
    document.body.appendChild(lightbox);
    var lbImg    = lightbox.querySelector('.furlo-lightbox__img');
    var lbClose  = lightbox.querySelector('.furlo-lightbox__close');
    var lbPrev   = lightbox.querySelector('.furlo-lightbox__nav--prev');
    var lbNext   = lightbox.querySelector('.furlo-lightbox__nav--next');

    function openLightbox() {
      if (!mainImg.src) return;
      lbImg.src = mainImg.src;
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lbClose.focus();
    }
    function closeLightbox() {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      if (mainWrap) mainWrap.focus();
    }

    function activateThumb(index) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (dotsEl) {
        var dots = dotsEl.querySelectorAll('.furlo-gallery__dot');
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }
      var countEl = document.getElementById('furlo-img-count');
      if (countEl) {
        countEl.textContent = (index + 1) + ' / ' + thumbs.length;
        countEl.setAttribute('aria-label', 'Image ' + (index + 1) + ' sur ' + thumbs.length);
      }
      var src = thumbs[index].getAttribute('data-src');
      var alt = thumbs[index].getAttribute('data-alt') || '';
      if (src) switchImage(src, alt);
    }

    function switchImage(src, alt) {
      mainImg.style.transition = 'opacity .2s ease';
      mainImg.style.opacity = '0';
      var loader = new Image();
      loader.onload = function () {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = src;
        if (alt) mainImg.alt = alt;
        mainImg.style.opacity = '1';
        if (lightbox.classList.contains('is-open')) lbImg.src = src;
      };
      loader.onerror = function () { mainImg.style.opacity = '1'; };
      loader.src = src;
    }

    // Thumb clicks
    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () { activateThumb(idx); });
      thumb.setAttribute('tabindex', '0');
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activateThumb(idx); }
      });
    });

    // Mobile swipe
    if (mainWrap) {
      var startX = 0; var didSwipe = false;
      mainWrap.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX; didSwipe = false;
      }, { passive: true });
      mainWrap.addEventListener('touchmove', function (e) {
        if (Math.abs(e.touches[0].clientX - startX) > 8) didSwipe = true;
      }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 48) return;
        var activeIdx = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        if (activeIdx < 0) activeIdx = 0;
        var nextIdx = diff > 0
          ? (activeIdx + 1) % thumbs.length
          : (activeIdx - 1 + thumbs.length) % thumbs.length;
        activateThumb(nextIdx);
      }, { passive: true });
    }

    // Desktop prev/next arrow buttons
    var prevBtn = document.getElementById('furlo-gal-prev');
    var nextBtn = document.getElementById('furlo-gal-next');
    if (prevBtn) prevBtn.addEventListener('click', function () {
      var ai = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      activateThumb((ai - 1 + thumbs.length) % thumbs.length);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var ai = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      activateThumb((ai + 1) % thumbs.length);
    });

    // Open lightbox on main image click (not on arrows / fav)
    if (mainWrap) {
      mainWrap.addEventListener('click', function (e) {
        if (didSwipe) { didSwipe = false; return; }
        if (e.target.closest('.furlo-gal-arrows') || e.target.closest('.furlo-gallery-bp__fav')) return;
        openLightbox();
      });
    }

    // Lightbox controls
    lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
    lbPrev.addEventListener('click', function () {
      var ai = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      activateThumb((ai - 1 + thumbs.length) % thumbs.length);
    });
    lbNext.addEventListener('click', function () {
      var ai = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      activateThumb((ai + 1) % thumbs.length);
    });

    // Unified keyboard handler (lightbox ESC/arrows + gallery arrows)
    document.addEventListener('keydown', function (e) {
      if (lightbox.classList.contains('is-open')) {
        if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); return; }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          var ai = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
          activateThumb((ai - 1 + thumbs.length) % thumbs.length);
          return;
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          var ai = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
          activateThumb((ai + 1) % thumbs.length);
          return;
        }
        return;
      }
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var tag = e.target && e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      var galleryEl = document.getElementById('furlo-gallery');
      if (!galleryEl) return;
      var activeIdx = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (activeIdx < 0) activeIdx = 0;
      var nextIdx = e.key === 'ArrowRight'
        ? (activeIdx + 1) % thumbs.length
        : (activeIdx - 1 + thumbs.length) % thumbs.length;
      e.preventDefault(); activateThumb(nextIdx);
    });

    // Expose for color swatch use
    window.furloGalleryActivate = function (color) {
      if (!color) return;
      var colorThumbs = thumbs.filter(function (t) {
        return t.getAttribute('data-color') === color;
      });
      if (colorThumbs.length) {
        var idx = thumbs.indexOf(colorThumbs[0]);
        if (idx >= 0) activateThumb(idx);
        return;
      }

      // Product media do not always carry a color-specific alt text.
      // Keep a deterministic fallback so the first bottle color still
      // controls the gallery while content is completed in Shopify.
      var fallbackIdx = color === 'rose' && thumbs.length > 1 ? 1 : 0;
      activateThumb(fallbackIdx);
    };
  }

  /* ============================================================
     COLOR SWATCHES
     ============================================================ */
  function syncPurchaseReminders() {
    var selected = document.querySelector(
      '[data-furlo-bundles] .furlo-bundle-item.is-selected, [data-furlo-bundles] .furlo-bundle.is-selected'
    );
    if (!selected) return;

    var packHeading = selected.querySelector('.furlo-pack-v2__info h4, h4, h3');
    var packLabel = selected.getAttribute('data-pack-label') ||
      (packHeading ? packHeading.textContent.trim() : 'Pack ' + (selected.getAttribute('data-pack') || ''));
    packLabel = packLabel.replace(/^Pack\s+/i, '');
    var price = selected.getAttribute('data-price') || '';
    var perUnit = selected.getAttribute('data-per-unit') || '';
    var savingNode = selected.querySelector('.save');
    var saving = savingNode ? savingNode.textContent.trim() : '';
    var colors = Array.from(selected.querySelectorAll('.furlo-bundle-swatches')).map(function (group) {
      var active = group.querySelector('.furlo-bundle-swatch.is-active');
      return active ? (active.getAttribute('data-value') || '').trim() : '';
    }).filter(Boolean);

    document.querySelectorAll('[data-furlo-mid-pack], [data-furlo-selection-pack], [data-furlo-cta-pack], [data-furlo-sticky-pack], [data-furlo-home-cta-pack]').forEach(function (node) {
      node.textContent = packLabel;
    });
    document.querySelectorAll('[data-furlo-mid-colors]').forEach(function (node) {
      node.textContent = colors.join(' + ');
    });
    document.querySelectorAll('[data-furlo-selection-per]').forEach(function (node) {
      node.textContent = perUnit;
      node.hidden = !perUnit;
    });
    document.querySelectorAll('[data-furlo-selection-save]').forEach(function (node) {
      node.textContent = saving;
      node.hidden = !saving;
    });
    if (price) {
      document.querySelectorAll('[data-furlo-mid-price], [data-furlo-home-cta-price]').forEach(function (node) {
        node.textContent = price;
      });
    }
  }

  function initColorSwatches() {
    var swatches   = Array.from(document.querySelectorAll('.furlo-swatch'));
    var colorNameEl = document.getElementById('furlo-color-name');
    var variantData = document.getElementById('furlo-variant-data');

    if (!swatches.length) return;

    var currentColor = 'rose';
    var colorLabels  = { rose: 'Rose poudré', bleu: 'Bleu ciel' };

    function applyColor(color) {
      if (color === currentColor && swatches.some(function(s){ return s.classList.contains('is-active'); })) return;
      currentColor = color;

      // Update swatch active state + aria
      swatches.forEach(function (s) {
        var active = s.getAttribute('data-color') === color;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      // Update color name label
      if (colorNameEl) colorNameEl.textContent = colorLabels[color] || color;

      // Update bundle buttons variant IDs and prices
      // Data attrs format: data-{color}-{pack} / data-{color}-{pack}-price / data-{color}-{pack}-compare
      if (variantData) {
        var bundles = Array.from(document.querySelectorAll('.furlo-bundle-item, .furlo-bundle'));
        bundles.forEach(function (item) {
          var pack    = item.getAttribute('data-pack') || '1';
          var vid     = variantData.getAttribute('data-' + color + '-' + pack);
          var price   = variantData.getAttribute('data-' + color + '-' + pack + '-price');
          var compare = variantData.getAttribute('data-' + color + '-' + pack + '-compare');
          if (vid)     item.setAttribute('data-variant-id', vid);
          if (price)   item.setAttribute('data-price', price);
          var priceMain = item.querySelector('.furlo-bundle__price-main');
          if (priceMain && price) priceMain.textContent = price;
          var priceS = item.querySelector('.furlo-bundle__compare');
          if (priceS && compare) priceS.textContent = compare;
        });
      }

      // Re-trigger selected item to update form + CTA price
      var selected = document.querySelector('.furlo-bundle-item.is-selected, .furlo-bundle.is-selected');
      if (selected) {
        var price = selected.getAttribute('data-price');
        var vid   = selected.getAttribute('data-variant-id');
        if (price) {
          document.querySelectorAll(
            '[data-furlo-price-main], [data-furlo-price-btn], [data-furlo-sticky-price]'
          ).forEach(function (n) {
            n.textContent = price;
          });
        }
        if (vid) {
          var variantInput = document.getElementById('furlo-variant-id');
          if (variantInput) { variantInput.value = vid; variantInput.setAttribute('value', vid); }
        }
      }

      // Switch gallery to color images
      if (window.furloGalleryActivate) window.furloGalleryActivate(color);
      syncPurchaseReminders();
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        applyColor(swatch.getAttribute('data-color'));
      });
    });
  }

  /* ============================================================
     BUNDLE PICKER — sélection pack + coloris intégrés
     ============================================================ */
  function initBundlePicker() {
    var root = document.querySelector('[data-furlo-bundles]');
    if (!root) return;

    var items = Array.from(root.querySelectorAll('.furlo-bundle-item, .furlo-bundle'));
    var variantMapEl = document.getElementById('furlo-bundle-variant-map');
    var bundleVariants = [];
    if (variantMapEl) {
      try { bundleVariants = JSON.parse(variantMapEl.textContent || '[]'); } catch (error) { bundleVariants = []; }
    }

    function resolveBundleVariant(item) {
      if (!item || !bundleVariants.length) return;
      var pack = item.getAttribute('data-pack') || '1';
      var colors = Array.from(item.querySelectorAll('.furlo-bundle-swatches')).map(function (group) {
        var active = group.querySelector('.furlo-bundle-swatch.is-active');
        var value = active ? (active.getAttribute('data-value') || '').toLowerCase() : '';
        return value.indexOf('rose') !== -1 ? 'rose' : 'bleu';
      });
      var roses = colors.filter(function (color) { return color === 'rose'; }).length;
      var bleues = colors.length - roses;
      var match = bundleVariants.find(function (candidate) {
        var title = (candidate.title || '').toLowerCase();
        if (pack === '1') return title.indexOf('solo') !== -1 && (roses === 1 ? title.indexOf('rose') !== -1 : title.indexOf('bleu') !== -1);
        if (pack === '2') {
          if (roses === 2) return title.indexOf('duo') !== -1 && title.indexOf('2 roses') !== -1;
          if (bleues === 2) return title.indexOf('duo') !== -1 && title.indexOf('2 bleu') !== -1;
          return title.indexOf('duo') !== -1 && title.indexOf('rose') !== -1 && title.indexOf('bleu') !== -1;
        }
        if (roses === 3) return title.indexOf('famille') !== -1 && title.indexOf('3 roses') !== -1;
        if (bleues === 3) return title.indexOf('famille') !== -1 && title.indexOf('3 bleu') !== -1;
        if (roses === 2) return title.indexOf('famille') !== -1 && title.indexOf('2 roses') !== -1 && title.indexOf('1 bleue') !== -1;
        return title.indexOf('famille') !== -1 && title.indexOf('1 rose') !== -1 && title.indexOf('2 bleu') !== -1;
      });
      if (!match) return;
      item.setAttribute('data-variant-id', match.id);
      item.setAttribute('data-price', match.price);
      var currentPrice = item.querySelector('.furlo-bundle__price-main');
      if (currentPrice) currentPrice.textContent = match.price;
      var oldPrice = item.querySelector('.furlo-pack-v2__price .old');
      if (oldPrice && match.compare) {
        oldPrice.textContent = match.compare;
        oldPrice.setAttribute('aria-label', 'Prix initial : ' + match.compare);
      }
    }

    var propInputs = [
      document.getElementById('furlo-prop-g1'),
      document.getElementById('furlo-prop-g2'),
      document.getElementById('furlo-prop-g3')
    ];

    function updateDisplayedPrice(price) {
      if (!price) return;
      document.querySelectorAll(
        '[data-furlo-price-main], [data-furlo-price-btn], [data-furlo-sticky-price]'
      ).forEach(function (node) {
        node.textContent = price;
      });
    }

    function clearPropInputs() {
      propInputs.forEach(function (inp) {
        if (inp) { inp.value = ''; inp.disabled = true; }
      });
    }

    function syncColorPanel(item) {
      item.querySelectorAll('.furlo-bundle-swatches').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-prop-idx') || '0', 10);
        var active = group.querySelector('.furlo-bundle-swatch.is-active');
        if (active && propInputs[idx]) {
          propInputs[idx].value = active.getAttribute('data-value') || '';
          propInputs[idx].disabled = false;
        }
      });
    }

    function selectItem(item) {
      resolveBundleVariant(item);
      items.forEach(function (i) {
        i.classList.remove('is-selected');
        i.setAttribute('aria-pressed', 'false');
      });
      item.classList.add('is-selected');
      item.setAttribute('aria-pressed', 'true');

      var price = item.getAttribute('data-price') || '';
      var vid   = item.getAttribute('data-variant-id');

      updateDisplayedPrice(price);
      var qtyHidden = document.getElementById('furlo-qty-hidden');
      if (qtyHidden) qtyHidden.value = '1';
      var packProperty = document.getElementById('furlo-pack-property');
      if (packProperty) packProperty.value = item.getAttribute('data-pack-label') || 'Pack ' + (item.getAttribute('data-pack') || '1');
      var bottlesProperty = document.getElementById('furlo-bottles-property');
      if (bottlesProperty) bottlesProperty.value = item.getAttribute('data-qty') || item.getAttribute('data-pack') || '1';
      var variantInput = document.getElementById('furlo-variant-id');
      if (vid && variantInput) { variantInput.value = vid; variantInput.setAttribute('value', vid); }

      clearPropInputs();
      syncColorPanel(item);
      syncPurchaseReminders();
    }

    // Wire item clicks (skip if target is a swatch button)
    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        if (e.target.closest('.furlo-bundle-swatch')) return;
        selectItem(item);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectItem(item);
        }
      });
    });

    // Wire swatch clicks — update hidden inputs directly
    root.querySelectorAll('.furlo-bundle-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.furlo-bundle-swatches');
        if (!group) return;
        group.querySelectorAll('.furlo-bundle-swatch').forEach(function (s) {
          s.classList.remove('is-active');
          s.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        var idx = parseInt(group.getAttribute('data-prop-idx') || '0', 10);
        if (propInputs[idx]) {
          propInputs[idx].value = btn.getAttribute('data-value') || '';
          propInputs[idx].disabled = false;
        }
        var item = btn.closest('.furlo-bundle-item, .furlo-bundle');
        resolveBundleVariant(item);
        if (item && item.classList.contains('is-selected')) {
          var variantInput = document.getElementById('furlo-variant-id');
          var variantId = item.getAttribute('data-variant-id');
          if (variantInput && variantId) { variantInput.value = variantId; variantInput.setAttribute('value', variantId); }
          updateDisplayedPrice(item.getAttribute('data-price') || '');
        }
        syncPurchaseReminders();
      });
    });

    // Init: sync inputs from default selected item
    var defaultSelected = root.querySelector('.furlo-bundle-item.is-selected, .furlo-bundle.is-selected');
    if (defaultSelected) {
      resolveBundleVariant(defaultSelected);
      var defaultVariantInput = document.getElementById('furlo-variant-id');
      var defaultVariantId = defaultSelected.getAttribute('data-variant-id');
      if (defaultVariantInput && defaultVariantId) { defaultVariantInput.value = defaultVariantId; defaultVariantInput.setAttribute('value', defaultVariantId); }
      items.forEach(function (item) {
        item.setAttribute('aria-pressed', item === defaultSelected ? 'true' : 'false');
      });
      clearPropInputs();
      syncColorPanel(defaultSelected);
      updateDisplayedPrice(defaultSelected.getAttribute('data-price') || '');
      syncPurchaseReminders();
    }

    function syncSelectedVariantInput() {
      var selectedItem = root.querySelector('.furlo-bundle-item.is-selected, .furlo-bundle.is-selected');
      if (!selectedItem) return;
      resolveBundleVariant(selectedItem);
      var input = document.getElementById('furlo-variant-id');
      var selectedId = selectedItem.getAttribute('data-variant-id') || '';
      if (input && selectedId) {
        input.value = selectedId;
        input.setAttribute('value', selectedId);
      }
    }
    root.addEventListener('click', function () { window.setTimeout(syncSelectedVariantInput, 0); });
    window.setTimeout(syncSelectedVariantInput, 0);
    window.setTimeout(syncSelectedVariantInput, 250);

  }

  function initTrustTicker() {
    document.querySelectorAll('[data-furlo-trust-ticker]').forEach(function (ticker) {
      var track = ticker.querySelector('[data-furlo-trust-track]');
      var items = Array.from(ticker.querySelectorAll('.furlo-v4-trust__item'));
      var dots = Array.from(ticker.querySelectorAll('[data-furlo-trust-dot]'));
      var mobile = window.matchMedia('(max-width: 749px)');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var index = 0;
      var timer = null;

      if (!track || items.length < 2) return;

      function render(nextIndex) {
        index = (nextIndex + items.length) % items.length;
        if (mobile.matches) {
          track.style.transform = 'translate3d(0,-' + (index * 72) + 'px,0)';
        } else {
          track.style.removeProperty('transform');
        }
        items.forEach(function (item, itemIndex) {
          item.setAttribute('aria-hidden', mobile.matches && itemIndex !== index ? 'true' : 'false');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!mobile.matches || reducedMotion.matches) return;
        timer = window.setInterval(function () {
          render(index + 1);
        }, 4500);
      }

      dots.forEach(function (dot, dotIndex) {
        dot.addEventListener('click', function () {
          render(dotIndex);
          start();
        });
      });

      ticker.addEventListener('pointerenter', stop);
      ticker.addEventListener('pointerleave', start);
      ticker.addEventListener('focusin', stop);
      ticker.addEventListener('focusout', start);
      ticker.addEventListener('touchstart', stop, { passive: true });
      ticker.addEventListener('touchend', start, { passive: true });

      mobile.addEventListener('change', function () {
        render(0);
        start();
      });
      reducedMotion.addEventListener('change', start);

      render(0);
      start();
    });
  }

  /* ============================================================
     STICKY ATC — visibility + proxy submit
     ============================================================ */
  function initSticky() {
    var sticky = document.getElementById('furlo-sticky-atc') ||
                 document.querySelector('.furlo-sticky-atc');
    var anchor = document.getElementById('furlo-buybox') ||
                 document.querySelector('.furlo-hero, .furlo-buybox');
    var mainCta = document.getElementById('furlo-add-to-cart');
    var stickyBtn = document.getElementById('furlo-sticky-btn');
    var exitZones = Array.from(document.querySelectorAll('.furlo-v4-final, .furlo-footer'));
    var mobile = window.matchMedia('(max-width: 749px)');
    var frame = 0;

    if (!sticky || !anchor) return;

    // Keep the bar outside theme sections so position: fixed always uses the
    // mobile viewport, including Safari containers and theme animations.
    if (sticky.parentElement !== document.body) document.body.appendChild(sticky);

    function setVisible(visible) {
      sticky.classList.toggle('is-visible', visible);
      sticky.classList.toggle('is-suppressed', !visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (stickyBtn) stickyBtn.setAttribute('tabindex', visible ? '0' : '-1');
    }

    function syncButtonState() {
      if (!stickyBtn || !mainCta) return;
      var disabled = mainCta.disabled || mainCta.getAttribute('aria-disabled') === 'true';
      stickyBtn.disabled = disabled;
      stickyBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function update() {
      frame = 0;
      var cartDrawer = document.querySelector('cart-drawer');
      var cartIsOpen = document.body.classList.contains('furlo-cart-open') ||
        (cartDrawer && cartDrawer.classList.contains('active'));
      if (cartIsOpen) {
        setVisible(false);
        return;
      }
      if (!mobile.matches) {
        setVisible(false);
        return;
      }

      // The mobile bar is available throughout the product journey. It only
      // yields when the primary CTA is already actionable in the viewport or
      // when the genuine end-of-page purchase/footer zones are visible. This
      // default-visible model remains usable if a mobile browser skips a
      // scroll event or reports an imprecise initial position.
      var trigger = mainCta || anchor;
      var triggerRect = trigger.getBoundingClientRect();
      var primaryCtaVisible = triggerRect.top < window.innerHeight &&
                              triggerRect.bottom > 0;
      var exitZoneVisible = exitZones.some(function (zone) {
        var exitRect = zone.getBoundingClientRect();
        return exitRect.top < window.innerHeight && exitRect.bottom > 0;
      });
      setVisible(!primaryCtaVisible && !exitZoneVisible);
      syncButtonState();
    }

    function scheduleUpdate() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleUpdate);
    document.addEventListener('touchmove', scheduleUpdate, { passive: true });
    document.addEventListener('touchend', scheduleUpdate, { passive: true });
    document.addEventListener('furlo:cart-state', scheduleUpdate);
    window.addEventListener('orientationchange', scheduleUpdate);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.visualViewport.addEventListener('resize', scheduleUpdate, { passive: true });
    }
    if (mobile.addEventListener) mobile.addEventListener('change', scheduleUpdate);
    else mobile.addListener(scheduleUpdate);

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(scheduleUpdate, {
        threshold: [0, 0.01, 1]
      });
      if (mainCta) visibilityObserver.observe(mainCta);
      exitZones.forEach(function (zone) { visibilityObserver.observe(zone); });
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      new MutationObserver(scheduleUpdate).observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (stickyBtn && mainCta) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled) return;
        mainCta.click();
      });

      new MutationObserver(syncButtonState).observe(mainCta, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
    }

    update();
  }

  function initMidPurchaseReminder() {
    var reminder = document.querySelector('[data-furlo-mid-cta]');
    var reminderBtn = reminder && reminder.querySelector('[data-furlo-mid-add]');
    var mainCta = document.getElementById('furlo-add-to-cart');
    if (!reminder || !reminderBtn || !mainCta) return;

    function syncState() {
      var disabled = mainCta.disabled || mainCta.getAttribute('aria-disabled') === 'true';
      reminderBtn.disabled = disabled;
      reminderBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      syncPurchaseReminders();
    }

    reminderBtn.addEventListener('click', function () {
      if (reminderBtn.disabled) return;
      mainCta.click();
    });

    new MutationObserver(syncState).observe(mainCta, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });
    syncState();
  }

  /* ============================================================
     UGC CARROUSEL — dots cliquables + flèches + reduced-motion
     ============================================================ */
  function initUgcCarousel() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = reducedMotion ? 'auto' : 'smooth';

    document.querySelectorAll('.furlo-ugc').forEach(function (ugc) {
      var track    = ugc.querySelector('.furlo-ugc__track');
      var dotsWrap = ugc.querySelector('.furlo-ugc__dots');
      var prev     = ugc.querySelector('.furlo-ugc__arrow--prev');
      var next     = ugc.querySelector('.furlo-ugc__arrow--next');
      if (!track) return;
      var cards = track.querySelectorAll('.furlo-ugc__card');
      if (!cards.length) return;

      cards.forEach(function (_, i) {
        var d = document.createElement('button');
        d.className = 'furlo-ugc__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Carte ' + (i + 1));
        d.addEventListener('click', function () {
          cards[i].scrollIntoView({ behavior: behavior, inline: 'start', block: 'nearest' });
        });
        if (dotsWrap) dotsWrap.appendChild(d);
      });

      function step() { return cards[0].offsetWidth + 16; }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: behavior }); });

      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / step());
        if (dotsWrap) {
          dotsWrap.querySelectorAll('.furlo-ugc__dot').forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === idx);
          });
        }
      }, { passive: true });
    });
  }

  /* ============================================================
     RATING STARS — couleur selon la note (DA Anthracite)
     ============================================================ */
  function ratingColor(score) {
    if (score >= 4.5) return 'var(--furlo-g5)';
    if (score >= 4.0) return 'var(--furlo-g4)';
    if (score >= 3.0) return 'var(--furlo-g3)';
    if (score >= 2.0) return 'var(--furlo-g2)';
    return 'var(--furlo-g1)';
  }

  function initRatingStars() {
    document.querySelectorAll('[data-furlo-rating]').forEach(function (el) {
      var raw = el.getAttribute('data-furlo-rating') || '';
      var score = parseFloat(raw.replace(',', '.'));
      if (isNaN(score)) return;
      var color = ratingColor(score);
      var filled = Math.round(score);
      el.querySelectorAll('svg').forEach(function (svg, i) {
        svg.style.fill = i < filled ? color : 'var(--furlo-mist)';
      });
    });
  }

  /* initBundleColorPanels remplacé par initBundlePicker ci-dessus */
  function initBundleColorPanels_DEPRECATED() {
    var propInputs = [
      document.getElementById('furlo-prop-g1'),
      document.getElementById('furlo-prop-g2'),
      document.getElementById('furlo-prop-g3')
    ];

    // Disable all property inputs (only enable those relevant to active pack)
    function clearPropInputs() {
      propInputs.forEach(function (inp) {
        if (inp) { inp.value = ''; inp.disabled = true; }
      });
    }

    // Sync active swatch values in a panel to hidden inputs
    function syncPanel(panel) {
      if (!panel) return;
      panel.querySelectorAll('.furlo-bundle-swatches').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-prop-idx') || '0', 10);
        var active = group.querySelector('.furlo-bundle-swatch.is-active');
        if (active && propInputs[idx]) {
          propInputs[idx].value = active.getAttribute('data-value') || '';
          propInputs[idx].disabled = false;
        }
      });
    }

    // Show panel for clicked pack, hide others
    function activatePanel(pack) {
      clearPropInputs();
      document.querySelectorAll('.furlo-bundle-colors').forEach(function (panel) {
        var match = panel.getAttribute('data-pack-colors') === String(pack);
        panel.hidden = !match;
        if (match) syncPanel(panel);
      });
    }

    // Wire swatch click events
    document.querySelectorAll('.furlo-bundle-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.furlo-bundle-swatches');
        if (!group) return;
        group.querySelectorAll('.furlo-bundle-swatch').forEach(function (s) {
          s.classList.remove('is-active');
          s.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        var idx = parseInt(group.getAttribute('data-prop-idx') || '0', 10);
        if (propInputs[idx]) {
          propInputs[idx].value = btn.getAttribute('data-value') || '';
          propInputs[idx].disabled = false;
        }
      });
    });

    // Wire bundle button clicks
    document.querySelectorAll('.furlo-bundle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        activatePanel(btn.getAttribute('data-pack') || '1');
      });
    });

    // Init with currently selected pack
    var selected = document.querySelector('.furlo-bundle.is-selected');
    if (selected) activatePanel(selected.getAttribute('data-pack') || '1');
  }

  /* ============================================================
     FAQ BP — DA Bleu Premium accordion
     ============================================================ */
  function initFaqBp() {
    document.querySelectorAll('[data-furlo-faq-bp] .furlo-faq-bp__q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.furlo-faq-bp__i');
        var wasOpen = item.classList.contains('is-open');
        document.querySelectorAll('[data-furlo-faq-bp] .furlo-faq-bp__i').forEach(function(i) {
          i.classList.remove('is-open');
          var plus = i.querySelector('.furlo-faq-plus, .furlo-faq-bp__plus');
          if (plus) plus.textContent = '+';
          i.querySelector('.furlo-faq-bp__q').setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          var plus = item.querySelector('.furlo-faq-plus, .furlo-faq-bp__plus');
          if (plus) plus.textContent = '–';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ============================================================
     PACK COLOR DISPLAY — swap gourde SVG color on swatch click (display only)
     ============================================================ */
  function initPackColorDisplay() {
    document.querySelectorAll('[data-furlo-bundles] .furlo-bundle-swatch').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.furlo-bundle-swatches');
        if (!group) return;
        var propIdx = group.getAttribute('data-prop-idx');
        var pack = btn.closest('.furlo-bundle');
        if (!pack) return;
        var val = btn.getAttribute('data-value') || '';
        var color = val.indexOf('Bleu') > -1 ? 'var(--furlo-sky)' : 'var(--furlo-pink)';
        var gourde = pack.querySelector('.furlo-gourde-svg[data-gourde-idx="' + propIdx + '"]');
        if (gourde) gourde.style.setProperty('--gc', color);

        // The first bottle selection is the visual source of truth for
        // the product gallery. Secondary bottles keep their own pack icon
        // without unexpectedly replacing the main media.
        if (propIdx === '0' && window.furloGalleryActivate) {
          window.furloGalleryActivate(val.indexOf('Bleu') > -1 ? 'bleu' : 'rose');
        }
      });
    });
  }

  /* ============================================================
     BUY BOX REVIEW CAROUSEL — compact, swipe + autoplay accessible
     ============================================================ */
  function initBuyboxReviewCarousel() {
    document.querySelectorAll('[data-furlo-buybox-review]').forEach(function (root) {
      if (root.dataset.furloReviewReady === 'true') return;
      root.dataset.furloReviewReady = 'true';
      var originals = Array.from(root.querySelectorAll('[data-furlo-buybox-review-slide]:not([data-furlo-review-clone])'));
      var track = root.querySelector('[data-furlo-buybox-review-track]');
      var dotsHost = root.querySelector('[data-furlo-buybox-review-dots]');
      var prev = root.querySelector('[data-furlo-buybox-review-prev]');
      var next = root.querySelector('[data-furlo-buybox-review-next]');
      if (!track || originals.length < 1) return;
      var count = originals.length;
      var position = count > 1 ? 1 : 0;
      var timer = null;
      var normalizeTimer = null;
      var startX = null;
      var startY = null;
      var hoverPaused = false;
      var focusPaused = false;
      var touching = false;
      var cartOpen = document.body.classList.contains('furlo-cart-open');
      var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      var reduceMotion = motionQuery && motionQuery.matches;
      var dots = [];
      if (count > 1) {
        var firstClone = originals[0].cloneNode(true);
        var lastClone = originals[count - 1].cloneNode(true);
        firstClone.removeAttribute('id');
        lastClone.removeAttribute('id');
        firstClone.setAttribute('data-furlo-review-clone', 'true');
        lastClone.setAttribute('data-furlo-review-clone', 'true');
        firstClone.setAttribute('aria-hidden', 'true');
        lastClone.setAttribute('aria-hidden', 'true');
        track.insertBefore(lastClone, originals[0]);
        track.appendChild(firstClone);
      }
      if (dotsHost && count > 1) {
        dotsHost.setAttribute('aria-hidden', 'true');
        dotsHost.removeAttribute('aria-label');
        originals.forEach(function () {
          var dot = document.createElement('span');
          dot.className = 'furlo-buybox-v10__review-dot';
          dotsHost.appendChild(dot);
          dots.push(dot);
        });
      }
      function realIndex() {
        if (count < 2) return 0;
        return ((position - 1) % count + count) % count;
      }
      function updateA11y() {
        var active = realIndex();
        originals.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === active);
        });
      }
      function render(animate) {
        if (count > 1 && (position < 0 || position > count + 1)) {
          position = realIndex() + 1;
          animate = false;
        }
        track.style.transition = animate && !reduceMotion
          ? 'transform .46s cubic-bezier(.22,.61,.36,1)'
          : 'none';
        track.style.transform = 'translate3d(-' + (position * 100) + '%,0,0)';
        updateA11y();
      }
      function normalize() {
        if (count < 2) return;
        if (position <= 0 || position >= count + 1) {
          position = realIndex() + 1;
          render(false);
        }
      }
      function scheduleNormalize() {
        if (normalizeTimer) window.clearTimeout(normalizeTimer);
        normalizeTimer = window.setTimeout(normalize, 560);
      }
      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }
      function play() {
        stop();
        if (!reduceMotion && !cartOpen && !hoverPaused && !focusPaused && !touching && !document.hidden && count > 1 && root.isConnected) {
          timer = window.setInterval(function () {
            if (!root.isConnected || cartOpen || document.hidden) {
              stop();
              return;
            }
            normalize();
            position += 1;
            render(true);
            scheduleNormalize();
          }, 4600);
        }
      }
      function move(delta, restart) {
        if (count < 2) return;
        normalize();
        position += delta;
        render(true);
        scheduleNormalize();
        if (restart) play();
      }
      track.addEventListener('transitionend', normalize);
      if (prev) prev.addEventListener('click', function () { move(-1, true); });
      if (next) next.addEventListener('click', function () { move(1, true); });
      root.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'touch') return;
        hoverPaused = true;
        stop();
      });
      root.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'touch') return;
        hoverPaused = false;
        play();
      });
      root.addEventListener('focusin', function () {
        focusPaused = true;
        stop();
      });
      root.addEventListener('focusout', function (event) {
        focusPaused = root.contains(event.relatedTarget);
        if (!focusPaused) play();
      });
      root.addEventListener('touchstart', function (event) {
        touching = true;
        stop();
        var touch = event.touches && event.touches.length === 1 ? event.touches[0] : null;
        startX = touch ? touch.clientX : null;
        startY = touch ? touch.clientY : null;
      }, { passive: true });
      root.addEventListener('touchend', function (event) {
        var touch = event.changedTouches && event.changedTouches[0];
        touching = Boolean(event.touches && event.touches.length);
        if (startX !== null && startY !== null && touch && !touching) {
          var deltaX = touch.clientX - startX;
          var deltaY = touch.clientY - startY;
          if (Math.abs(deltaX) > 38 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
            move(deltaX < 0 ? 1 : -1, false);
          }
        }
        startX = null;
        startY = null;
        play();
      }, { passive: true });
      root.addEventListener('touchcancel', function () {
        touching = false;
        startX = null;
        startY = null;
        play();
      }, { passive: true });
      if (motionQuery && motionQuery.addEventListener) {
        motionQuery.addEventListener('change', function (event) {
          reduceMotion = event.matches;
          normalize();
          render(false);
          play();
        });
      }
      document.addEventListener('furlo:cart-state', function (event) {
        cartOpen = Boolean(event.detail && event.detail.open);
        if (cartOpen) {
          stop();
          normalize();
        } else {
          position = count > 1 ? realIndex() + 1 : 0;
          render(false);
          play();
        }
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else play();
      });
      window.addEventListener('pageshow', function () {
        position = count > 1 ? realIndex() + 1 : 0;
        render(false);
        play();
      });
      render(false);
      play();
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  ready(function () {
    initGallery();
    initColorSwatches();
    initFaq();
    initFaqBp();
    initBundlePicker();
    initBuyboxReviewCarousel();
    initPackColorDisplay();
    initTrustTicker();
    initSticky();
    initMidPurchaseReminder();
    initUgcCarousel();
    initRatingStars();
  });

  document.addEventListener('shopify:section:load', function () {
    initBuyboxReviewCarousel();
  });

})();
